export const AI_CHAT_INPUT = 'ai-chat-input';
